<section>
  <mat-card>
    <div class="title" aria-label="Filtros de Pesquisa">
      <h2 class="text-lg font-semibold">Filtros de Pesquisa</h2>
      <button class="clear-filters-btn" mat-flat-button (click)="resetFilters()" title="Limpar campos do formulário">
        <mat-icon>delete_sweep</mat-icon>
        <span>Limpar campos</span>
      </button>
    </div>
    <form class="form-filters" [formGroup]="filterForm" aria-label="Formulário de filtros">
      <custom-input [title]="'Data Inicial'">
        <mat-form-field appearance="outline">
          <input
            matInput
            class="calender"
            [matDatepicker]="startPicker"
            formControlName="startDate"
            placeholder="Data Inicial"
            readonly
            title="Campo de data inicial, preencha utilizando o seletor"
            (input)="formatDate($event)"
            (click)="startPicker.open()" />
          <mat-icon matSuffix class="calender" (click)="startPicker.open()">calendar_today</mat-icon>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
      </custom-input>
      <custom-input [title]="'Data Final'">
        <mat-form-field appearance="outline">
          <input
            matInput
            class="calender"
            [matDatepicker]="endPicker"
            formControlName="endDate"
            placeholder="Data Final"
            readonly
            title="Campo de data final, preencha utilizando o seletor"
            (input)="formatDate($event)"
            (click)="endPicker.open()" />
          <mat-icon matSuffix class="calender" (click)="endPicker.open()">calendar_today</mat-icon>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </custom-input>
      <custom-input [title]="'Tipo de Busca'">
        <mat-form-field appearance="outline">
          <mat-select title="Campo de tipo de busca, preencha utilizando o seletor" formControlName="searchType" aria-label="Tipo de busca">
            <mat-option [value]="1">CNPJ</mat-option>
            <mat-option [value]="2">RAZÃO SOCIAL</mat-option>
          </mat-select>
        </mat-form-field>
      </custom-input>
      <custom-input [title]="'Busca'" class="col-span">
        <mat-form-field appearance="outline">
          <ng-container [ngSwitch]="filterForm.get('searchType').value">
            <input
              matInput
              *ngSwitchCase="1"
              title="Campo de busca por CNPJ"
              formControlName="filterText"
              placeholder="01.234.567/0001-00"
              [textMask]="{
                mask: fiscalNumberMask,
                guide: false,
                keepCharPositions: true
              }"
              (keypress)="onPressEnterSearchCompanies($event)" />
            <input
              matInput
              *ngSwitchCase="2"
              title="Campo de busca por Razão Social"
              formControlName="filterText"
              placeholder="Razão Social"
              (keypress)="onPressEnterSearchCompanies($event)" />
          </ng-container>
        </mat-form-field>
      </custom-input>
      <button mat-button class="search-button" (click)="searchWithFilters()" title="Pesquisar empresas">
        Pesquisar
        <mat-icon aria-hidden="true">search</mat-icon>
      </button>
    </form>
  </mat-card>
</section>

<main>
  <mat-card>
    <div class="info-network" role="alert">
      <p class="font-medium">
        Selecione as empresas com fechamento financeiro para baixar os arquivos correspondentes e clique no botão de download para baixar o arquivo
        individualmente. Caso necessite baixar mais de um arquivo, selecione os registros desejado e clique em “Baixar Selecionados”.
      </p>
      <p class="text-sm">A seleção em massa dos arquivos funciona apenas para a aba selecionada.</p>
    </div>
    <nav class="actions-bar" aria-label="Ações de download">
      <button *ngIf="selection.selected.length > 1" mat-button class="download-button" (click)="downloadSelectedReports()" title="Baixar relatórios selecionados">
        <mat-icon>check_circle_outline</mat-icon>
        BAIXAR SELECIONADAS
      </button>
    </nav>

    <section class="table-container-resume" aria-label="Tabela de empresas">
      <table mat-table [dataSource]="dataSource" aria-label="Tabela de empresas">
        <!-- Checkbox -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="header-checkbox">
            <mat-checkbox
              title="Selecionar todos"
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="table-checkbox">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="selection.toggle(row)"
              [checked]="selection.isSelected(row)"
              [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Coluna CNPJ -->
        <ng-container matColumnDef="fiscalNumber">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element" class="no-wrap">{{ element.fiscalNumber | companyFederalNumber }}</td>
        </ng-container>

        <!-- Razão Social -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Razão Social</th>
          <td mat-cell *matCellDef="let element">
            <div class="no-wrap" [matTooltip]="element.companyName">{{ element.companyName }}</div>
          </td>
        </ng-container>

        <!-- Funcionários -->
        <ng-container matColumnDef="beneficiaries">
          <th mat-header-cell *matHeaderCellDef>Beneficiários</th>
          <td mat-cell *matCellDef="let element">{{ element.employeeCount | number }}</td>
        </ng-container>

        <!-- Período -->
        <ng-container matColumnDef="dates">
          <th mat-header-cell *matHeaderCellDef>Período</th>
          <td mat-cell *matCellDef="let element">
            De {{ element.cycleBalanceStartDate | date : "dd/MM/yyyy" }} até {{ element.cycleBalanceEndDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <!-- Baixar -->
        <ng-container matColumnDef="download">
          <th mat-header-cell *matHeaderCellDef>Baixar</th>
          <td mat-cell *matCellDef="let element">
            <button mat-mini-fab class="btn-action-download" (click)="downloadReport(element)" title="Download do relatório individual">
              <mat-icon>download</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"></tr>
      </table>

      <div class="no-data" role="alert" *ngIf="dataSource.data.length === 0">
        <mat-icon aria-hidden="true">inbox</mat-icon>
        <span>Nenhum registro encontrado.</span>
      </div>
    </section>

    <mat-paginator
      [pageSizeOptions]="[10, 20, 50, 100]"
      showFirstLastButtons
      [length]="getSalesLength()"
      [pageIndex]="getPageIndex()"
      (page)="searchWithFilters($event)">
    </mat-paginator>
  </mat-card>
</main>

<footer>
  <button mat-flat-button class="back-btn" (click)="backToHome()" title="Voltar ao início">
    <mat-icon aria-hidden="true">west</mat-icon>
    <span>VOLTAR AO INÍCIO</span>
  </button>
</footer>